import Wireless from "../assets/js/paquetes/wireless";
import FOptica from "../assets/js/paquetes/fOptica";
import FOpticaTel from "../assets/js/paquetes/fOpticaTel";
import ZonasCobertura from "./../assets/js/zonasCobert";
import BotonesPaquetes from "../assets/js/paquetes/Botones";

import TitulosSeccions from "../components/TitulosSeccions";
import Boton from "../components/Boton";
import CardPaquetes from "../components/CardPaquetes";
import Footers from "./../components/Footers";

import useSelectPackage from "./../assets/hooks/useSelectPackage";

import "animate.css";

const Paquetes = () => {
  const { typePackage, selectPackage } = useSelectPackage();
  return (
    <>
      <section className="object-cover object-right w-full h-full md:h-full md:w-full md:object-center">
        <div className="container px-8 py-4 mx-auto md:py-20 sm:py-5">
          <TitulosSeccions
            cssStyle="text-center text-3xl font-bold text-cerulean py-2 animate__animated animate__bounceInDown"
            title="Selecciona tu municipio"
          />
          <div className="flex flex-col items-center justify-center">
            <select
              className="xxl:w-[400px] md:w-[300px] sm:w-full h-11 rounded-md text-xl text-gray900 animate__animated animate__rollIn"
              onChange={(e) => selectPackage(e.target.value)}
            >
              {ZonasCobertura.map((item) => (
                <option
                  key={item.id}
                  value={item.type}
                  className="relative rounded-lg"
                >
                  {item.title}
                </option>
              ))}
            </select>
            <div className="flex flex-row items-center justify-center gap-2 animate__animated animate__rollIn py-7">
              {typePackage != "wireless"
                ? BotonesPaquetes.map((item) => (
                    <Boton
                      key={item.id}
                      icon={item.icon}
                      title={item.title}
                      iconDos={item.iconDos}
                      subtitle={item.subtitle}
                      css={item.style}
                      evenClick={(e) => selectPackage(item.event)}
                    />
                  ))
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-1 gap-3 p-6 lg:grid-cols-3 md:grid-cols-2 md:py-8 animate__animated animate__zoomIn">
            {typePackage === ""
              ? FOptica.map((item) => (
                  <CardPaquetes
                    data={item}
                    key={item.id}
                    styleCardHeader={item.styleCardHeader}
                  />
                ))
              : (() => {
                  switch (typePackage) {
                    case "": {
                      // case "wireless": {
                      return Wireless.map((item) => (
                        <CardPaquetes data={item} key={item.id} />
                      ));
                    }
                    case "fiberOptic":
                      return FOptica.map((item) => (
                        <CardPaquetes data={item} key={item.id} />
                      ));
                    case "fiberOptTel":
                      return FOpticaTel.map((item) => (
                        <CardPaquetes data={item} key={item.id} />
                      ));
                    default:
                      return "";
                  }
                })()}
          </div>
        </div>
      </section>
      <Footers />
    </>
  );
};

export default Paquetes;
